export const generateLocalConfigText = (r, BASE_URL = 'https://wifi.useopenfi.com') => {
  const token          = r.token       || '<token_not_set>';

  if ((r.type || 'other') === 'mikrotik') {
    const hotspotProfile = r.hotspotName || 'hsprof1';
    const hotspotIP      = '10.5.50.1';
    const hotspotPool    = '10.5.50.2-10.5.50.254';
    const hotspotNet     = '10.5.50.0/24';
    const bridgeIface    = 'bridge-hotspot';
    const radiusIP       = '159.89.108.156';
    const radiusSecret   = 'aRak@2520openfi';
    const adminPass      = r.adminPass   || 'FiOpen@2020%';
    const customSsid     = r.ssid        || null;
    // Escape characters that would break a RouterOS string literal
    const rosEscape      = (s) => String(s).replace(/[\\"$]/g, (c) => `\\${c}`);
    const ssidLine       = customSsid
      ? `:local ssid "${rosEscape(customSsid)}"`
      : `:local ssid ("OpenFi-" . $routerId)`;

    // Voucher revocation script source - ends with non-quote char to avoid parser ambiguity
    const voucherSrc = [
      `:local routerId [/system identity get name]`,
      `:local url (\\"https://io.useopenfi.com/platform/portal/revoke_list?router=\\" . \\$routerId)`,
      `:local fname \\"revokes.txt\\"`,
      `:if ([:len [/file find name=\\$fname]] > 0) do={ /file remove \\$fname }`,
      `/tool fetch url=\\$url mode=https http-method=get dst-path=\\$fname`,
      `:delay 1`,
      `:if ([:len [/file find name=\\$fname]] = 0) do={ :return }`,
      `:local data [/file get \\$fname contents]`,
      `:local dataLen [:len \\$data]`,
      `:if (\\$dataLen = 0) do={ /file remove \\$fname; :return }`,
      `:local lineCount 0`,
      `:local i 0`,
      `:local cur \\"\\"`,
      `:while (\\$i < \\$dataLen) do={`,
      `:local c [:pick \\$data \\$i]`,
      `:if (\\$c = \\"\\\\n\\") do={`,
      `:if ([:len \\$cur] > 0) do={`,
      `/ip hotspot active remove [find user=\\$cur]`,
      `/ip hotspot cookie remove [find user=\\$cur]`,
      `/ip hotspot host remove [find user=\\$cur authorized=yes]`,
      `:set lineCount (\\$lineCount + 1)`,
      `:set cur \\"\\"`,
      `}`,
      `} else={ :if (\\$c != \\"\\\\r\\") do={ :set cur (\\$cur . \\$c) } }`,
      `:set i (\\$i + 1)`,
      `}`,
      `:if ([:len \\$cur] > 0) do={`,
      `/ip hotspot active remove [find user=\\$cur]`,
      `/ip hotspot cookie remove [find user=\\$cur]`,
      `/ip hotspot host remove [find user=\\$cur authorized=yes]`,
      `:set lineCount (\\$lineCount + 1)`,
      `}`,
      `:log info (\\$lineCount . \\" vouchers revoked\\")`,
      `/file remove \\$fname`,
    ].join('\\r\\n');

    // MAC disconnect script source - ends with non-quote char
    const macSrc = [
      `:local routerId [/system identity get name]`,
      `:local url (\\"https://io.useopenfi.com/platform/portal/mac_disconnect_list?router=\\" . \\$routerId)`,
      `:local fname \\"mac_disc.txt\\"`,
      `:if ([:len [/file find name=\\$fname]] > 0) do={ /file remove \\$fname }`,
      `/tool fetch url=\\$url mode=https http-method=get dst-path=\\$fname`,
      `:delay 1`,
      `:if ([:len [/file find name=\\$fname]] = 0) do={ :return }`,
      `:local data [/file get \\$fname contents]`,
      `:local dataLen [:len \\$data]`,
      `:if (\\$dataLen = 0) do={ /file remove \\$fname; :return }`,
      `:local i 0`,
      `:local cur \\"\\"`,
      `:while (\\$i < \\$dataLen) do={`,
      `:local c [:pick \\$data \\$i]`,
      `:if (\\$c = \\"\\\\n\\") do={`,
      `:if ([:len \\$cur] > 0) do={`,
      `/ip hotspot active remove [find mac-address=\\$cur]`,
      `/ip hotspot cookie remove [find mac-address=\\$cur]`,
      `/ip hotspot host remove [find mac-address=\\$cur authorized=yes]`,
      `:set cur \\"\\"`,
      `}`,
      `} else={ :if (\\$c != \\"\\\\r\\") do={ :set cur (\\$cur . \\$c) } }`,
      `:set i (\\$i + 1)`,
      `}`,
      `:if ([:len \\$cur] > 0) do={`,
      `/ip hotspot active remove [find mac-address=\\$cur]`,
      `/ip hotspot cookie remove [find mac-address=\\$cur]`,
      `/ip hotspot host remove [find mac-address=\\$cur authorized=yes]`,
      `}`,
      `/file remove \\$fname`,
    ].join('\\r\\n');

    return [
      `# OpenFi Full Bootstrap for MikroTik (${r.name || 'Unnamed Router'})`,
      `# WARNING: Wipes existing config and replaces with OpenFi setup`,
      `# Idempotent - safe to re-run`,
      ``,

      `# PHASE 0: REMEMBER WORKING WAN (Phase 1 wipes DHCP clients)`,
      `:local prevWan ""`,
      `:foreach c in=[/ip dhcp-client find where disabled=no] do={`,
      `  :if (([:len $prevWan] = 0) && ([/ip dhcp-client get $c status] = "bound")) do={`,
      `    :set prevWan [/ip dhcp-client get $c interface]`,
      `  }`,
      `}`,
      ``,

      `# PHASE 1: RESET`,
      `/ip hotspot remove [find]`,
      `# Note: RouterOS v6 only accepts != inside "find where"`,
      `/ip hotspot profile remove [find where name!="default"]`,
      `/ip hotspot walled-garden remove [find]`,
      `/ip hotspot walled-garden ip remove [find]`,
      `/ip hotspot user remove [find where name!="default" name!="default-trial"]`,
      `/ip hotspot cookie remove [find]`,
      `/radius remove [find]`,
      `/radius incoming set accept=no`,
      `/ip address remove [find where dynamic=no interface!="lo" interface!="loopback"]`,
      `/ip dhcp-server remove [find]`,
      `/ip pool remove [find]`,
      `/ip dhcp-server network remove [find]`,
      `/ip dhcp-client remove [find]`,
      `/interface bridge port remove [find bridge=${bridgeIface}]`,
      `/interface bridge remove [find name="${bridgeIface}"]`,
      `/ip dns static remove [find]`,
      `/ip firewall filter remove [find dynamic=no]`,
      `/ip firewall nat remove [find dynamic=no]`,
      `/ip firewall address-list remove [find]`,
      `/system script remove [find name=revocation_cron]`,
      `/system script remove [find name=mac_disconnect_cron]`,
      `/system scheduler remove [find name=revocation_scheduler]`,
      `/system scheduler remove [find name=mac_disconnect_scheduler]`,
      `/user set [find name=admin] password="${adminPass}"`,
      `:log info "PHASE 1 complete: Config wiped"`,
      ``,

      `# PHASE 2: IDENTITY`,
      `# Read MACs from the generic /interface menu so routers without the wireless package still parse`,
      `:local wlanMac ""`,
      `:if ([:len [/interface find where name="wlan1"]] > 0) do={`,
      `  :set wlanMac [/interface get [find where name="wlan1"] mac-address]`,
      `}`,
      `:if ([:len $wlanMac] = 0) do={`,
      `  # Fallback: try common names then first available ethernet`,
      `  :local firstEth ""`,
      `  :foreach e in={"ether1-isp";"ether1-gateway";"ether1-uplink";"ether1";"sfp1";"sfp-sfpplus1"} do={`,
      `    :if ([:len $firstEth] = 0) do={`,
      `      :if ([:len [/interface find where name=$e]] > 0) do={ :set firstEth $e }`,
      `    }`,
      `  }`,
      `  :if ([:len $firstEth] = 0) do={`,
      `    :local ethList [/interface ethernet find]`,
      `    :if ([:len $ethList] > 0) do={`,
      `      :set firstEth [/interface ethernet get [:pick $ethList 0] name]`,
      `    }`,
      `  }`,
      `  :if ([:len $firstEth] = 0) do={ :set firstEth "ether1" }`,
      `  :set wlanMac [/interface get [find where name=$firstEth] mac-address]`,
      `  :log warning ("wlan1 not found, using " . $firstEth . " MAC")`,
      `}`,
      `:local routerId ("OPENFI-" . $wlanMac)`,
      `/system identity set name=$routerId`,
      `:log info ("PHASE 2 complete: Identity=" . $routerId)`,
      ``,

      `# PHASE 3: WAN - auto-detect WAN interface`,
      `:local wanIface ""`,
      `# 1st: interface that had a bound DHCP lease before the reset`,
      `:if ([:len $prevWan] > 0) do={`,
      `  :if ([:len [/interface find where name=$prevWan]] > 0) do={ :set wanIface $prevWan }`,
      `}`,
      `# 2nd: common names, preferring one with link up`,
      `:foreach candidate in={"ether1-isp";"ether1-gateway";"ether1-uplink";"ether1";"sfp1";"sfp-sfpplus1";"sfp-sfpplus1-sfpplus1";"combo1"} do={`,
      `  :if ([:len $wanIface] = 0) do={`,
      `    :if ([:len [/interface find where name=$candidate running=yes]] > 0) do={`,
      `      :set wanIface $candidate`,
      `    }`,
      `  }`,
      `}`,
      `# 3rd: common names regardless of link state`,
      `:foreach candidate in={"ether1-isp";"ether1-gateway";"ether1-uplink";"ether1";"sfp1";"sfp-sfpplus1";"sfp-sfpplus1-sfpplus1";"combo1"} do={`,
      `  :if ([:len $wanIface] = 0) do={`,
      `    :if ([:len [/interface find where name=$candidate]] > 0) do={`,
      `      :set wanIface $candidate`,
      `    }`,
      `  }`,
      `}`,
      `# 4th: fall back to whichever ethernet interface index is lowest`,
      `:if ([:len $wanIface] = 0) do={`,
      `  :local ethList [/interface ethernet find]`,
      `  :if ([:len $ethList] > 0) do={`,
      `    :set wanIface [/interface ethernet get [:pick $ethList 0] name]`,
      `  }`,
      `}`,
      `# 5th: try any non-bridge, non-loopback, non-wlan interface`,
      `:if ([:len $wanIface] = 0) do={`,
      `  :local ifList [/interface find where type!="bridge" type!="loopback" type!="wlan" type!="wifi"]`,
      `  :if ([:len $ifList] > 0) do={`,
      `    :set wanIface [/interface get [:pick $ifList 0] name]`,
      `  }`,
      `}`,
      `:if ([:len $wanIface] = 0) do={`,
      `  :log error "WAN interface not found - defaulting to ether1"`,
      `  :set wanIface "ether1"`,
      `}`,
      `:log info ("PHASE 3: WAN interface=" . $wanIface)`,
      `:if ([:len [/interface find where name=$wanIface running=yes]] = 0) do={`,
      `  :log warning ("WAN interface " . $wanIface . " has no link - plug the uplink into it or edit the DHCP client")`,
      `}`,
      `/ip dhcp-client add interface=$wanIface disabled=no add-default-route=yes use-peer-dns=yes`,
      `:log info ("PHASE 3 complete: WAN DHCP on " . $wanIface)`,
      ``,

      `# PHASE 4: BRIDGE`,
      `/interface bridge add name=${bridgeIface} protocol-mode=rstp`,
      `# Every ethernet + wireless port except WAN. Ports are first pulled out of any`,
      `# other bridge (e.g. the factory "bridge" on hAP), otherwise the add fails.`,
      `:foreach i in=[/interface find where (type="ether" || type="wlan" || type="wifi")] do={`,
      `  :local iface [/interface get $i name]`,
      `  :if ($iface != $wanIface) do={`,
      `    /interface bridge port remove [find where interface=$iface]`,
      `    /interface bridge port add bridge=${bridgeIface} interface=$iface`,
      `  }`,
      `}`,
      `/ip address add address=${hotspotIP}/24 interface=${bridgeIface}`,
      `:log info "PHASE 4 complete: Bridge created"`,
      ``,

      `# PHASE 5: WIRELESS`,
      ssidLine,
      `# Each wireless menu only exists if its package is installed, so these are parsed`,
      `# at runtime and errors ignored. Network is left open (the hotspot handles login).`,
      `# Legacy "wireless" package (v6 and v7)`,
      `:do { [[:parse "/interface wireless security-profiles set [find default=yes] mode=none"]] } on-error={}`,
      `:do { [[:parse ("/interface wireless set [find] mode=ap-bridge ssid=\\"" . $ssid . "\\" disabled=no")]] } on-error={}`,
      `# v7 "wifi" package (7.13+) and older "wifiwave2"`,
      `:foreach menu in={"wifi";"wifiwave2"} do={`,
      `  :do { [[:parse ("/interface " . $menu . " set [find] configuration.mode=ap configuration.ssid=\\"" . $ssid . "\\" disabled=no")]] } on-error={}`,
      `  :do { [[:parse ("/interface " . $menu . " set [find] security.authentication-types=\\"\\"")]] } on-error={}`,
      `}`,
      `:log info ("PHASE 5 complete: SSID=" . $ssid)`,
      ``,

      `# PHASE 6: DHCP SERVER`,
      `/ip pool add name=hs-pool ranges=${hotspotPool}`,
      `/ip dhcp-server add name=hotspot-dhcp interface=${bridgeIface} address-pool=hs-pool disabled=no lease-time=01:00:00`,
      `/ip dhcp-server network add address=${hotspotNet} gateway=${hotspotIP} dns-server=${hotspotIP}`,
      `:log info "PHASE 6 complete: DHCP configured"`,
      ``,

      `# PHASE 7: NAT`,
      `/ip firewall nat add chain=srcnat out-interface=$wanIface action=masquerade`,
      `/ip firewall nat add chain=srcnat src-address=${hotspotNet} action=masquerade`,
      `:log info "PHASE 7 complete: NAT configured"`,
      ``,

      `# PHASE 8: DNS`,
      `/ip dns set allow-remote-requests=yes servers=8.8.8.8,8.8.4.4 cache-max-ttl=1s`,
      `/ip dns static add name=wifi.useopenfi.com address=${radiusIP}`,
      `/ip dns static add name=access.openfi address=${hotspotIP}`,
      `/ip dns cache flush`,
      `:log info "PHASE 8 complete: DNS configured"`,
      ``,

      `# PHASE 9: FIREWALL`,
      `/ip firewall filter add chain=input connection-state=established,related action=accept`,
      `/ip firewall filter add chain=forward connection-state=established,related action=accept`,
      `/ip firewall filter add chain=input in-interface=${bridgeIface} protocol=udp dst-port=53 action=accept`,
      `/ip firewall filter add chain=input in-interface=${bridgeIface} protocol=tcp dst-port=53 action=accept`,
      `/ip firewall filter add chain=input in-interface=${bridgeIface} protocol=udp dst-port=67 action=accept`,
      `/ip firewall filter add chain=input in-interface=${bridgeIface} protocol=tcp dst-port=64872-64875 action=accept`,
      `/ip firewall filter add chain=input protocol=udp src-address=${radiusIP} dst-port=3799 action=accept`,
      `/ip firewall filter add chain=input connection-state=invalid action=drop`,
      `/ip firewall filter add chain=forward connection-state=invalid action=drop`,
      `:log info "PHASE 9 complete: Firewall configured"`,
      ``,

      `# PHASE 10: HOTSPOT PROFILE`,
      `# Small-flash routers (hAP lite, hAP ac lite...) lose files outside flash/ on reboot`,
      `:local hsDir "hotspot"`,
      `:if ([:len [/file find where name="flash" type="directory"]] > 0) do={ :set hsDir "flash/hotspot" }`,
      `/ip hotspot profile add name=${hotspotProfile} hotspot-address=${hotspotIP} dns-name=access.openfi html-directory=$hsDir http-proxy=0.0.0.0:64872 login-by=http-pap,mac-cookie use-radius=yes radius-interim-update=00:02:00 nas-port-type=wireless-802.11 radius-mac-format=XX:XX:XX:XX:XX:XX`,
      `:log info "PHASE 10 complete: Hotspot profile created"`,
      ``,

      `# PHASE 11: HOTSPOT INSTANCE`,
      `/ip hotspot add name=hotspot1 interface=${bridgeIface} address-pool=hs-pool profile=${hotspotProfile} idle-timeout=00:05:00 addresses-per-mac=2 disabled=no`,
      `:log info "PHASE 11 complete: Hotspot instance created"`,
      ``,

      `# PHASE 12: WALLED GARDEN`,
      `# Only whitelist portal - probe domains must NOT be here or popup will not trigger`,
      `/ip hotspot walled-garden add dst-host=wifi.useopenfi.com`,
      `/ip hotspot walled-garden add dst-host=*.useopenfi.com`,
      `/ip hotspot walled-garden add dst-host=*.araknerd.com`,
      `/ip hotspot walled-garden add dst-host=wifi.openfi`,
      `:log info "PHASE 12 complete: Walled garden configured"`,
      ``,

      `# PHASE 13: RADIUS`,
      `/radius add service=hotspot address=${radiusIP} secret="${rosEscape(radiusSecret)}" timeout=3s authentication-port=1812 accounting-port=1813`,
      `# require-message-auth only exists on newer RouterOS (6.49.15+ / 7.15+); older versions reject it`,
      `:do { [[:parse "/radius set [find where service~\\"hotspot\\"] require-message-auth=no"]] } on-error={}`,
      `/radius enable [find where service~"hotspot"]`,
      `/radius incoming set accept=yes port=3799`,
      `:log info "PHASE 13 complete: RADIUS configured"`,
      ``,

      `# PHASE 14: REVOCATION CRONS`,
      `/system script add name=revocation_cron source="${voucherSrc}"`,
      `/system script add name=mac_disconnect_cron source="${macSrc}"`,
      `/system scheduler add name=revocation_scheduler start-time=startup interval=00:01:00 on-event=revocation_cron disabled=no`,
      `/system scheduler add name=mac_disconnect_scheduler start-time=startup interval=00:01:00 on-event=mac_disconnect_cron disabled=no`,
      `:log info "PHASE 14 complete: Revocation crons configured"`,
      ``,

      `# PHASE 15: HOTSPOT PAGES`,
      `# Wait up to 60s for the WAN DHCP lease / default route (Phase 1 dropped it)`,
      `:local waited 0`,
      `:while (([:len [/ip route find where dst-address=0.0.0.0/0 active]] = 0) && ($waited < 60)) do={`,
      `  :delay 1s`,
      `  :set waited ($waited + 1)`,
      `}`,
      `:if ([:len [/ip route find where dst-address=0.0.0.0/0 active]] = 0) do={`,
      `  :log error "No default route after 60s - check the WAN cable/DHCP on $wanIface; page downloads will fail"`,
      `}`,
      `:log info "PHASE 15: Downloading hotspot pages..."`,
      `# Retry each page so a slow WAN can't abort the import`,
      `:local pagesOk 0`,
      `:foreach page in={"login.html";"status.html";"alogin.html";"logout.html";"error.html"} do={`,
      `  :local done false`,
      `  :local tries 0`,
      `  :while ((!$done) && ($tries < 5)) do={`,
      `    :set tries ($tries + 1)`,
      `    :do {`,
      `      /tool fetch url=("https://wifi.useopenfi.com/hotspot/" . $page) dst-path=($hsDir . "/" . $page)`,
      `      :set done true`,
      `    } on-error={`,
      `      :log warning ("Fetch " . $page . " failed (try " . $tries . "/5) - retrying in 5s")`,
      `      :delay 5s`,
      `    }`,
      `  }`,
      `  :if ($done) do={`,
      `    :set pagesOk ($pagesOk + 1)`,
      `  } else={`,
      `    :log error ("Could not download " . $page . " - re-run the import once WAN is up")`,
      `  }`,
      `}`,
      `:log info ("PHASE 15 complete: " . $pagesOk . "/5 hotspot pages installed")`,
      ``,

      `# PHASE 16: SUMMARY`,
      `/ip dns cache flush`,
      `:log info "=== OpenFi Bootstrap Complete ==="`,
      `:log info ("  Identity : " . [/system identity get name])`,
      `:if ([:len [/interface find where (type="wlan" || type="wifi")]] > 0) do={`,
      `  :log info ("  SSID     : " . $ssid)`,
      `} else={`,
      `  :log info "  SSID     : N/A (no wireless)"`,
      `}`,
      `:log info "  Hotspot  : ${hotspotIP}"`,
      `:log info "  Portal   : access.openfi"`,
      `/system identity print`,
      `# End of OpenFi bootstrap`,
      ``
    ].join('\r\n');
  }

  if ((r.type || 'other') === 'cisco') {
    return [
      `! OpenFi bootstrap placeholder for Cisco (${r.name})`,
      `! ${BASE_URL}/routers/${r.id}/config?type=cisco&token=${token}`,
      ``
    ].join('\r\n');
  }
  if ((r.type || 'other') === 'ubiquiti') {
    return [
      `# OpenFi bootstrap placeholder for Ubiquiti (${r.name})`,
      `# ${BASE_URL}/routers/${r.id}/config?type=ubiquiti&token=${token}`,
      ``
    ].join('\n');
  }
  return [
    `# OpenFi generic bootstrap (${r.name})`,
    `# ${BASE_URL}/routers/${r.id}/config?type=${r.type || 'other'}&token=${token}`,
    ``
  ].join('\n');
};